"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const axios_1 = __importDefault(require("axios"));
const floating_vue_1 = require("floating-vue");
let AcceptUpgradedTerms = class AcceptUpgradedTerms extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.enableAction = false;
        this.sending = false;
        this.termUrl = '/policies/terms';
    }
    enableButton() {
        this.enableAction = true;
    }
    accept() {
        if (!this.enableAction || this.sending)
            return;
        this.sending = true;
        axios_1.default.post('/terms/accepted', {})
            .then(response => {
            window.location.href = response.request.responseURL || '/dashboard';
        })
            .catch(error => {
            if (error.response) {
                // Server responded with a status code outside the range of 2xx
                console.error('Error resending verification email:', error.response.data);
            }
            else if (error.request) {
                // Request was made but no response received
                console.error('No response received:', error.request);
            }
            else {
                // Something else happened during setup
                console.error('Error setting up request:', error.message);
            }
        }).finally(() => setTimeout(() => this.sending = false, 1000));
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], AcceptUpgradedTerms.prototype, "raw_user", void 0);
AcceptUpgradedTerms = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            FullsizeTemplate: bmk_ui_framework_1.FullsizeTemplate,
            Modal: bmk_ui_framework_1.Modal,
            Inbox: lucide_vue_next_1.Inbox,
            Button: bmk_ui_framework_1.Button,
            ArrowLeft: lucide_vue_next_1.ArrowLeft,
            Dropdown: floating_vue_1.Dropdown
        }
    })
], AcceptUpgradedTerms);
exports.default = AcceptUpgradedTerms;
